export enum AppointmentStatusType {
    Scheduled = 1,
    Pending = 2,
    Attended = 3,
    Cancelled = 4,
    InProgress = 5,
}
export const AppointmentStatusTypeLabels: Record<AppointmentStatusType, string> = {
    [AppointmentStatusType.Scheduled]: "Scheduled",
    [AppointmentStatusType.Pending]: "Pending",
    [AppointmentStatusType.Attended]: "Attended",
    [AppointmentStatusType.Cancelled]: "Cancelled",
    [AppointmentStatusType.InProgress]: "InProgress",
};
